// extracted by mini-css-extract-plugin
export default {"wrapper":"Textarea_wrapper__eIiXv","input":"Textarea_input__gMy4M"};